export default {
      id: "Icon--locationGeneric-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--locationGeneric",
      toString: function () {
        return this.url;
      }
    }